import * as s from "./schema";
import {getGdnColorStateKey, GDN_COLOR_VARIANTS, type GdnColorVariants} from "../libs/gdnColorCycle";
import {assertGdnTagRecord, normalizeGdnTagOrder} from "../libs/gdnTags";

export const EXTRA_TEXT_FIELDS = {name2: "names2", name3: "names3", name4: "names4", name5: "names5", name6: "names6", position2: "positions2", time: "times"} as const;
export const TEMPLATE_APPEARANCE_FIELDS = {variant: "variantOption", titleSize: "titleFontSize", buttonEnabled: "isButtonEnabled", gdnAccentColor: "gdnAccentColor", gdnColorVariants: "gdnColorVariants"} as const;
export const extraContentSchema = s.shape({
  ...Object.fromEntries(Object.keys(EXTRA_TEXT_FIELDS).map((field) => [field, s.optional(s.text)])) as {[K in keyof typeof EXTRA_TEXT_FIELDS]: ReturnType<typeof s.optional<string>>},
  gdnTags: s.optional(s.dictionary(s.text)), gdnTagOrder: s.optional(s.array(s.text)),
});
export const gdnColorsSchema: s.Validator<GdnColorVariants> = (value, path = "gdnColorVariants") => {
  const record = s.dictionary(s.text)(value, path);
  for (const [key, variant] of Object.entries(record)) {
    getGdnColorStateKey(key);
    if (!(GDN_COLOR_VARIANTS as readonly string[]).includes(variant)) s.fail(`${path}.${key}`, "Expected black, white or accent");
  }
  return value as GdnColorVariants;
};
export const titleSizeSchema: s.Validator<"default" | "small"> = (value, path = "titleSize") => {
  if (value !== "default" && value !== "small") s.fail(path, "Expected default or small");
  return value as "default" | "small";
};
export const templateAppearanceSchema = s.shape({variant: s.optional(s.range(1, 3, true)), titleSize: s.optional(titleSizeSchema),
  buttonEnabled: s.optional(s.boolean), gdnAccentColor: s.optional(s.nullable((value, path) => {
    const color = s.text(value, path);
    if (!/^#[0-9a-f]{6}$/i.test(color)) s.fail(path, "Expected #rrggbb color");
    return color;
  })), gdnColorVariants: s.optional(gdnColorsSchema)});
export type ExtraContent = Partial<ReturnType<typeof extraContentSchema>>;
export type TemplateAppearance = Partial<ReturnType<typeof templateAppearanceSchema>>;
export function validateGdnTags(content: ExtraContent) {
  if ((content.gdnTags === undefined) !== (content.gdnTagOrder === undefined)) s.fail("content.gdnTags", "GDN tags and order must be supplied together");
  if (content.gdnTags !== undefined) {
    assertGdnTagRecord(content.gdnTags);
    normalizeGdnTagOrder(content.gdnTagOrder, content.gdnTags);
    if (content.gdnTagOrder!.length !== Object.keys(content.gdnTags).length) s.fail("content.gdnTagOrder", "Order must contain every tag exactly once");
  }
}
